<template>
  <v-list dense>
    <template v-for="(item, index) in menuItems">
      <v-list-tile
        :key="index"
        :to="item.route">
        <v-list-tile-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>
            {{ $t(item.text) }}
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </template>
  </v-list>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SidebarBlock',
  computed: {
    ...mapGetters('user', ['getUser', 'hasTrial']),
    menuItems () {
      const menu = [
        { icon: 'business', text: 'company', route: { name: 'company' } },
        { icon: 'contacts', text: 'employees', route: { name: 'employees' } },
        { icon: 'history', text: 'timesheets', route: { name: 'timetracking' } },
        { icon: 'receipt', text: 'invoices', route: { name: 'invoices' } }, // for cm
        { icon: 'archive', text: 'archives', route: { name: 'archives' } }, // for cm
        // { icon: 'person_add', text: 'referrals', route: { name: 'referrals' } },
        { icon: 'settings', text: 'settings', route: { name: 'settings' } }
      ].filter(entry => {
        return this.$can('enterRoute', entry.route.name)
      })

      const isBillableUser = ['company_manager', 'user'].includes(this.getUser.role)
      const hasPaidSubscription = this.getUser.subscription_data &&
        this.getUser.subscription_data.active &&
        !this.getUser.subscription_data.manual_payment

      if (this.hasCompany) {
        if (isBillableUser || this.hasTrial || hasPaidSubscription) {
          menu.push({ icon: 'payment', text: 'subscription', route: { name: 'subscription' } })
        }
      }

      return menu
    },
    hasCompany () {
      const { has_company } = this.getUser
      return has_company
    }
  },
  i18n: {
    messages: {
      de: {
        company: 'Firma',
        companies: 'Firmen',
        dashboard: 'Übersicht',
        employees: 'Angestellte',
        help: 'Hilfe',
        referrals: 'Empfehlungen',
        settings: 'Einstellungen',
        subscription: 'Abonnement',
        timesheets: 'Stundenzettel',
        users: 'Benutzer',
        invoices: 'Rechnungen',
        archives: 'Archiv'
      },
      en: {
        company: 'Company',
        companies: 'Companies',
        dashboard: 'Overview',
        employees: 'Employees',
        help: 'Help',
        referrals: 'Referrals',
        settings: 'Settings',
        subscription: 'Subscription',
        timesheets: 'Times sheets',
        users: 'Users',
        invoices: 'Invoices',
        archives: 'Archive'
      },
      tr: {
        company: 'Şirket',
        companies: 'Şirketler',
        dashboard: 'Genel',
        employees: 'Çalışanlar',
        help: 'Yardım',
        referrals: 'Yönlendirmeler',
        settings: 'Ayarlar',
        subscription: 'Üyelik',
        timesheets: 'Zaman Çizelgesi',
        users: 'Kullanıcılar',
        invoices: 'Faturalar',
        archives: 'Arşiv'
      },
      ru: {
        company: 'Компания',
        companies: 'Компании',
        dashboard: 'Обзор',
        employees: 'Сотрудники',
        help: 'Помощь',
        referrals: 'Рефералы',
        settings: 'Настройки',
        subscription: 'Подписка',
        timesheets: 'Табель',
        users: 'Пользователи',
        invoices: 'Инвойсы',
        archives: 'Архивы'
      }
    }
  }
}
</script>

<style scoped>

</style>
